import React, { useState } from "react";
import { signUp, confirmSignUp, signIn } from "../api/auth";
import "./AuthPage.css"; // Import the stylesheet

function AuthPage({ setAuthToken }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [step, setStep] = useState("signin"); // "signup" | "confirm" | "signin"
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSignUp = async () => {
    setLoading(true);
    setError("");
    try {
      await signUp(username, password, email);
      setStep("confirm");
    } catch (err) {
      setError("Sign up failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmSignUp = async () => {
    setLoading(true);
    setError("");
    try {
      await confirmSignUp(username, code);
      setStep("signin");
    } catch (err) {
      setError("Confirmation failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSignIn = async () => {
    setLoading(true);
    setError("");
    try {
      const result = await signIn(username, password);
      setAuthToken(result.IdToken);
      localStorage.setItem("authToken", result.IdToken);
      localStorage.setItem("refreshToken", result.RefreshToken);
      localStorage.setItem("tokenExpiry", Date.now() + result.ExpiresIn * 1000);
      localStorage.setItem("userEmail", result.email);
      setEmail(result.email);
    } catch (err) {
      setError("Sign in failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const renderInputField = (placeholder, value, onChange, type = "text") => (
    <input
      className="input-field"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      type={type}
    />
  );

  return (
    <div className="auth-container">
      {/* Toggle Buttons */}
      <div className="toggle-container">
        <button
          className={`toggle-button ${step === "signin" ? "active" : ""}`}
          onClick={() => setStep("signin")}
        >
          Sign In
        </button>
        <button
          className={`toggle-button ${step === "signup" ? "active" : ""}`}
          onClick={() => setStep("signup")}
        >
          Sign Up
        </button>
      </div>

      {/* Forms based on `step` */}
      {step === "signup" && (
        <>
          <h2>Sign Up</h2>
          {renderInputField("Username", username, (e) => setUsername(e.target.value))}
          {renderInputField("Password", password, (e) => setPassword(e.target.value), "password")}
          {renderInputField("Email", email, (e) => setEmail(e.target.value))}
          <button className="submit-button" onClick={handleSignUp} disabled={loading}>
            {loading ? "Signing Up..." : "Sign Up"}
          </button>
          {error && <p className="error-message">{error}</p>}
        </>
      )}

      {step === "confirm" && (
        <>
          <h2>Confirm Sign Up</h2>
          {renderInputField("Confirmation Code", code, (e) => setCode(e.target.value))}
          <button className="submit-button" onClick={handleConfirmSignUp} disabled={loading}>
            {loading ? "Confirming..." : "Confirm"}
          </button>
          {error && <p className="error-message">{error}</p>}
        </>
      )}

      {step === "signin" && (
        <>
          <h2>Sign In</h2>
          {renderInputField("Username", username, (e) => setUsername(e.target.value))}
          {renderInputField("Password", password, (e) => setPassword(e.target.value), "password")}
          <button className="submit-button" onClick={handleSignIn} disabled={loading}>
            {loading ? "Signing In..." : "Sign In"}
          </button>
          {error && <p className="error-message">{error}</p>}
        </>
      )}
    </div>
  );
}

export default AuthPage;